<script >
import { ref, computed } from '@vue/composition-api';
import dayjs from 'dayjs';
import { default as Card } from '@/components/card';
import { dashboardService } from '@/api/towerControl/dashboard';
import { useQuery } from '@tanstack/vue-query';
import i18n from '@/lang';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    data
  } = useQuery({
    queryKey: ['getDailyCollectFee'],
    queryFn: async () => {
      try {
        const currentDate = new Date();
        const formatedDate = dayjs(currentDate).format('YYYY/MM/DD');
        const res = await dashboardService.getDailyCollectFee(formatedDate);
        return res;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          return {};
        }
        throw error;
      }
    },
    networkMode: 'always',
    refetchOnWindowFocus: false,
    retry: 3,
    keepPreviousData: false,
    refetchInterval: 300000
  });
  const dataCollectPackage = computed(() => {
    const collected = data.value?.data?.packagesCollect ?? 0;
    const uncollected = data.value?.data?.packagesToBeCollect ?? 0;
    return [collected, uncollected];
  });
  const chartOptions = ref({
    chart: {
      width: 380,
      type: 'donut'
    },
    dataLabels: {
      enabled: true,
      formatter(val, opts) {
        return [val.toFixed(0) + '%'];
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          show: false
        }
      }
    }],
    colors: ['#219F54', '#FF4040'],
    labels: [i18n.t('dashboard.collectedPackages'), i18n.t('dashboard.uncollectedPackages')],
    legend: {
      show: false,
      position: 'right',
      offsetY: 0,
      height: 230
    }
  });
  return {
    dataCollectPackage,
    chartOptions
  };
};
__sfc_main.components = Object.assign({
  Card
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
  <Card width="100%" class="container">
    <div class="container-header">
      <h2 class="header-2 m-t-20">{{ $t('dashboard.packageCollection') }}</h2>

      <div class="legends">
        <p class="label-1">{{ $t('dashboard.collectedPackages') }}: {{ dataCollectPackage[0] }}</p>
        <p class="label-2">{{ $t('dashboard.uncollectedPackages') }}: {{ dataCollectPackage[1] }}</p>
      </div>
    </div>
    <apexchart type="donut" width="400" :options="chartOptions" :series="dataCollectPackage" />
  </Card>
</template>

<style scoped>
.container{
  display: grid;
  gap: 1.25rem;
  justify-items: center;
}

.container-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.label-1::before, .label-2::before {
  content: '';
  display: inline-block;
  border-radius: 2px;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  vertical-align: text-top;
}

.label-1::before {
  background: #219F54;
}

.label-2::before {
  background: #FF4040;
}

.label-1, .label-2 {
  font-size: 0.75rem; /* 12px */
}

.legends {
  display: flex;
  gap: 1rem;
}
</style>
